/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import Stack from '@mui/material/Stack'
import { Chip } from '@mui/material'


export default function DataTableData(appId) {
  const AppService = useAppServices()
  const [list, setList] = useState([])
  const [loader, setLoader] = useState(true)
  const [categories, setCategories] = useState([])

  const getOnboard = async () => {
    const { response } = await AppService.AppsMedia.get_onboard({
      toaster: false,
    })
    if (response) {
      console.log(response?.data, "response?.data")
      setList(response?.data?.filter(item => item.category_id.app_id === appId))

    } else {
      setList([])
    }
    setLoader(false)
  }
  const getCategory = async () => {
    const { response } = await AppService.AppsMedia.get_category({
      toaster: false,
    })
    if (response) {
      setCategories(response.data)
    } else {
      setCategories([])
    }
    setLoader(false)
  }

  const onLoad = () => {
    getOnboard()
    getCategory()
  }

  const handleDelete = async (id) => {
    const { response } = await AppService.AppsMedia.delete_onboard({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(onLoad, [])


  return {
    loader: loader,
    categories: categories,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Name', accessor: 'name' },
        // { Header: 'Description', accessor: 'description' },
        { Header: 'category_name', accessor: 'category_name' },
        { Header: 'app_name', accessor: 'app_name' },
        { Header: 'video_path', accessor: 'video_path' },

        { Header: 'Action', accessor: 'action' },
      ],
      rows: list.map((data) => ({
        name: data?.name,
        // description: data?.description,
        category_name: data?.category_id?.name,
        app_name: data?.category_id?.app_name,
        video_path: data?.video_path,


        action: (
          <MDBox>
            <EditModal data={data} categories={categories} handleRefresh={onLoad} />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(data?._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}
